import React from "react";
import AdSlot300x250 from "../Ads/AdSlot300x250";
import AdSlot728x90 from "../Ads/AdSlot728x90";

const PointsTable = ({ pointsData, scrolled = false }) => {
  return (
    <div className="w-full mb-3 ">
      {pointsData?.map((group, groupIndex) => (
        <div
          key={groupIndex}
          className="w-full border border-gray-300 mb-4 rounded-md overflow-hidden"
        >
          <div className="flex justify-between bg-gray-200 px-4 py-2 font-semibold text-sm border-b border-gray-300">
            <div className="w-[40%]">{`Group ${group.name} Teams`}</div>
            <div className="w-[60%] flex justify-between">
              <div className="w-[10%] text-center">P</div>
              <div className="w-[10%] text-center">W</div>
              <div className="w-[10%] text-center">L</div>
              <div className="w-[10%] text-center">D</div>
              <div className="w-[10%] text-center">NR</div>
              <div className="w-[20%] text-center">NRR</div>
              <div className="w-[15%] text-center">Points</div>
            </div>
          </div>

          {group?.team?.map((item, index) => (
            <div
              key={index}
              className={`flex justify-between items-center px-4 py-2 text-sm ${
                index % 2 === 0 ? "bg-white" : "bg-gray-100"
              } border-b last:border-b-0`}
            >
              <div className="w-[40%] flex items-center gap-2">
                <img
                  width={24}
                  height={24}
                  alt="point_team"
                  src={
                    `https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/${item?.id}.png` ||
                    `https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/0.png`
                  }
                  // src={`https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${item?.short_name?.toLowerCase()}1.png`}
                />
                <span>{item?.short_name || "NA"}</span>
              </div>
              <div className="w-[60%] flex justify-between text-center">
                <div className="w-[10%]">{item?.p || 0}</div>
                <div className="w-[10%]">{item?.w || 0}</div>
                <div className="w-[10%]">{item?.l || 0}</div>
                <div className="w-[10%]">{item?.d || 0}</div>
                <div className="w-[10%]">{item?.nr || 0}</div>
                <div className="w-[20%]">{item?.nrr || "-"}</div>
                <div className="w-[15%]">{item?.pts || 0}</div>
              </div>
            </div>
          ))}
        </div>
      ))}
      {scrolled && (
        <AdSlot300x250
          divId="div-gpt-ad-1659434604998-0"
          minWidth="300px"
          minHeight="250px"
        />
      )}

      {scrolled && (
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-2"
          minWidth="728px"
          minHeight="90px"
        />
      )}
    </div>
  );
};

export default PointsTable;
